import { render, staticRenderFns } from "./MenuDropdownItem.vue?vue&type=template&id=92a785e4&"
import script from "./MenuDropdownItem.vue?vue&type=script&lang=js&"
export * from "./MenuDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports